enum MaterialPatrimonyLegalProtectionTypeEnum {
    LISTING = 'LISTING', //Tombamento
    REGISTRATION = 'REGISTRATION', //Registro,
}
//Registro, Tombamento, Paisagem cultural chancelada, Inscrição na lista do Patrimônio Cultural Ferroviário, Inscrição na lista do Patrimônio Cultural do Mercosul, Inscrição na lista do Patrimônio Cultural Mundial, Registro de sítio arqueológico

export default MaterialPatrimonyLegalProtectionTypeEnum;
